<template>
  <div>
    <job-menu :job="job"></job-menu>

    <div class="my-10 px-4">
      <div class="flex justify-center items-center">
        <h1 class="text-3xl font-bold text-center w-full mb-5 md:mb-0 md:w-auto">
          {{ __('Move car to a new location for job #:id', {id: job.id}) }}
        </h1>
      </div>

      <div class="bg-white px-4 py-10 shadow-md mt-10 overflow-x-auto">
        <div class="max-w-5xl mx-auto">

          <select-input :label="__('Location')" v-model="form.location">
            <option :value="location.id" v-for="location of carLocations">{{ location.label }}</option>
          </select-input>

          <div class="mt-10 flex justify">
            <button :disabled="!job.permissions.update" @click="storeCarLocation()" class="h-16 flex items-center justify-center text-2xl px-8 min-w-40 py-2 rounded text-white bg-coral-400 hover:bg-coral-300">
              {{ __("Save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import Layout from '@/Shared/Layout';
  import SelectInput from '@/Shared/SelectInput';
  import JobMenu from "../Jobs/JobMenu";

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__('Move car to a new location for job #:id', {id: this.job.id}),
      }
    },
    props: {
      job: Object,
      locations: Array
    },
    components: {
      Layout,
      SelectInput,
      JobMenu
    },
    data() {
      return {
        carLocations: this.locations,
        form: {
          location: ''
        }
      }
    },
    mounted() {
      this.form.operations = this.job.operations;
      this.form.media = this.job.media;
    },
    methods: {
      storeCarLocation() {
        if (confirm(this.__("Confirm"))) {
          this.$inertia.post(this.route('carPosition.store', {job: this.job.id}), {
            location: this.form.location
          });
        }
      }
    }
  }
</script>
